/**
 * Motivos da recusa da proposta pelo agente (PC-11) — espelho do `InitialProposalRejectionReason` do servidor, que o
 * exige fora da inversão de fases e o põe na frente da descrição, para a tela, o chat e a ata. As hipóteses de preço
 * (art. 59, III e IV) só cabem depois dos lances.
 */
export enum ProposalRejectionReason {
	COMPETITIVENESS = 'COMPETITIVENESS',
	INCURABLE_DEFECT = 'INCURABLE_DEFECT',
	TECHNICAL_SPECIFICATIONS = 'TECHNICAL_SPECIFICATIONS',
	PRICE = 'PRICE',
	FEASIBILITY_NOT_SHOWN = 'FEASIBILITY_NOT_SHOWN',
	OTHER_REQUIREMENT = 'OTHER_REQUIREMENT'
}

export const PROPOSAL_REJECTION_REASONS: Array<{ value: ProposalRejectionReason; label: string }> = [
	{ value: ProposalRejectionReason.COMPETITIVENESS, label: 'Compromete, restringe ou frustra o caráter competitivo (IN SEGES/ME 73/2022, art. 21, § 4º)' },
	{ value: ProposalRejectionReason.INCURABLE_DEFECT, label: 'Vício insanável (Lei 14.133/2021, art. 59, I)' },
	{ value: ProposalRejectionReason.TECHNICAL_SPECIFICATIONS, label: 'Não atende às especificações técnicas do edital (Lei 14.133/2021, art. 59, II)' },
	{ value: ProposalRejectionReason.PRICE, label: 'Preço inexequível ou acima do orçamento estimado (Lei 14.133/2021, art. 59, III)' },
	{ value: ProposalRejectionReason.FEASIBILITY_NOT_SHOWN, label: 'Exequibilidade não demonstrada (Lei 14.133/2021, art. 59, IV)' },
	{ value: ProposalRejectionReason.OTHER_REQUIREMENT, label: 'Desconformidade insanável com exigência do edital (Lei 14.133/2021, art. 59, V)' }
]
